// This file was generated automatically as a part of the SourceWhale ES6 refactor 🐳.
import { initializeGeneralUtils } from "@sourcewhale/shared/src/assets/js/src/general/utils";
import { initializeAttachments } from "@sourcewhale/shared/src/assets/js/src/sidebar/campaigns/attachments.js";
import { conditionallyBindModularization } from "../../../svelte/src/bindings/modularization.js";
import { initializeSidebar } from "../../../svelte/src/bindings/sidebar.js";
import { bindSystemBannerNotifications } from "../../../svelte/src/bindings/system-banner-notifications.js";
import { bindTestPanel } from "../../../svelte/src/bindings/test-panel-prod.js";
import { bindTodosModal } from "../../../svelte/src/bindings/todos-modal.js";
import { initializeConfig } from "../src/general/config.js";
import { initializeCleartext } from "../src/general/elements/cleartext.js";
import { initializeTinymce } from "../src/general/elements/tinymce.js";
import { initializeTheme } from "../src/general/theme.js";
import { initializeTracking } from "../src/general/tracking.js";
import { initializeVisibilities } from "../src/general/visibilities.js";
import { initializeMarketingModal } from "../src/marketing/marketing.js";
import { initializeOutbox } from "../src/sidebar/outbox.js";
import { initializeUploads } from "../src/uploads/uploads.js";
import { initializeWins } from "../src/wins/wins.js";

bindTestPanel();
bindSystemBannerNotifications();
bindTodosModal();
initializeTheme();
initializeConfig();
initializeVisibilities();
initializeGeneralUtils();
initializeSidebar();
initializeTracking();
initializeWins();
initializeUploads();
initializeMarketingModal();

conditionallyBindModularization({
  licensesRequired: ["outreach"],
  success: () => {
    initializeTinymce();
    initializeOutbox();
    initializeCleartext();
    initializeAttachments();
  },
});
